import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';
import toast from 'react-hot-toast';

export const useSuperAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        // Check if user is admin
        const { data: adminData } = await supabase
          .from('admin_users_mt2024')
          .select('*')
          .eq('user_id', session.user.id)
          .eq('role', 'super_admin')
          .single();
        
        setIsAdmin(!!adminData);
      }
    } catch (error) {
      console.error('Error checking admin status:', error);
    } finally {
      setLoading(false);
    }
  };

  const signInAsAdmin = async (email, password) => {
    try {
      // First, sign in with Supabase Auth
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;

      // Check if user is admin
      const { data: adminData, error: adminError } = await supabase
        .from('admin_users_mt2024')
        .select('*')
        .eq('user_id', data.user.id)
        .eq('role', 'super_admin')
        .single();

      if (adminError || !adminData) {
        await supabase.auth.signOut();
        throw new Error('Access denied. Admin privileges required.');
      }

      setIsAdmin(true);
      return { data, error: null };
    } catch (error) {
      console.error('Admin sign in error:', error);
      return { data: null, error };
    }
  };

  const signOutAdmin = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      setIsAdmin(false);
      return { error: null };
    } catch (error) {
      console.error('Admin sign out error:', error);
      return { error };
    }
  };

  return {
    isAdmin,
    loading,
    signInAsAdmin,
    signOutAdmin,
    checkAdminStatus
  };
};